import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'amountWithCommas'
})

export class AmountWithCommasPipe implements PipeTransform {

    transform(amount: any) {
        if (amount !== null && amount !== undefined) {
            const result = amount.toString().split('.');
            let lastThree = result[0].substring(result[0].length - 3);
            const otherNumbers = result[0].substring(0, result[0].length - 3);
            if (otherNumbers !== '') {
                lastThree = ',' + lastThree;
            }
            let output = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ',') + lastThree + '';

            if (result.length > 1) {
                output += '.' + result[1];
            } else {
              output += '.00';
            }
            return output;
        } else {
            return 0;
        }
    }
}
